export const MARKETPLACE_OPERATOR_BASE_PATH = "/account/operator";

export function getMarketplaceOperatorHubPath() {
  return MARKETPLACE_OPERATOR_BASE_PATH;
}

export function getMarketplaceOperatorWorkspacesPath() {
  return `${MARKETPLACE_OPERATOR_BASE_PATH}/workspaces`;
}

export function getMarketplaceOperatorAgreementsPath(search = "") {
  return `${MARKETPLACE_OPERATOR_BASE_PATH}/agreements${search || ""}`;
}

export function getMarketplaceOperatorPaymentsPath() {
  return `${MARKETPLACE_OPERATOR_BASE_PATH}/payments`;
}

export function getMarketplaceOperatorWorkspaceCreatePath() {
  return `${MARKETPLACE_OPERATOR_BASE_PATH}/workspaces/new`;
}

export function getMarketplaceOperatorWorkspaceDetailPath(id) {
  return `${MARKETPLACE_OPERATOR_BASE_PATH}/workspaces/${id}`;
}

export function getMarketplaceOperatorWorkspaceEditPath(id) {
  return `${MARKETPLACE_OPERATOR_BASE_PATH}/workspaces/${id}/edit`;
}

export function getMarketplaceOperatorWorkspaceCompliancePath(id) {
  return `${MARKETPLACE_OPERATOR_BASE_PATH}/workspaces/${id}/compliance`;
}

export function getMarketplaceOperatorWorkspaceOwnershipPath(id) {
  return `${MARKETPLACE_OPERATOR_BASE_PATH}/workspaces/${id}/ownership`;
}

export function getMarketplaceOperatorWorkspaceAgreementsPath(id) {
  return `${MARKETPLACE_OPERATOR_BASE_PATH}/workspaces/${id}/agreements`;
}

export function getMarketplaceOperatorWorkspaceWarningsPath(id) {
  return `${MARKETPLACE_OPERATOR_BASE_PATH}/workspaces/${id}/warnings`;
}

export function getMarketplaceOperatorWorkspaceSupportPath(id) {
  return `${MARKETPLACE_OPERATOR_BASE_PATH}/workspaces/${id}/support`;
}

export function getMarketplaceOperatorBookingsPath(search = "") {
  return getMarketplaceOperatorAgreementsPath(search);
}

export function getMarketplaceOperatorLeasesPath(search = "") {
  return getMarketplaceOperatorAgreementsPath(search);
}

export function getMarketplaceOperatorSettingsPath() {
  return `${MARKETPLACE_OPERATOR_BASE_PATH}/settings`;
}

export function getMarketplaceOperatorPayoutsPath() {
  return `${MARKETPLACE_OPERATOR_BASE_PATH}/payouts`;
}

export function getMarketplaceOperatorLedgerPath() {
  return `${MARKETPLACE_OPERATOR_BASE_PATH}/ledger`;
}

export function getMarketplaceOperatorAdminBillingPath() {
  return getMarketplaceOperatorPaymentsPath();
}
